import { Component } from "@angular/core";
import { SplitPreviewService } from "src/app/services/split-preview.service";
import { SplitPreviewState, SplitPreviewTab } from "src/app/services/split-preview.service";

@Component({
  selector: "split-preview-overlay",
  templateUrl: "./split-preview.component.html",
  styleUrls: ["./split-preview.component.scss"],
})
export class SplitPreviewComponent {
  state$ = this.splitPreviewService.state$;

  constructor(private splitPreviewService: SplitPreviewService) {}

  close() {
    this.splitPreviewService.close();
  }

  closeTab(tabId: string) {
    this.splitPreviewService.closeTab(tabId);
  }

  setActive(tabId: string) {
    this.splitPreviewService.setActiveTab(tabId);
  }

  trackTab(_index: number, tab: SplitPreviewTab) {
    return tab.id;
  }

  getActiveTab(state: SplitPreviewState): SplitPreviewTab | null {
    if (!state?.tabs?.length) {
      return null;
    }
    const found = state.tabs.find((t) => t.id === state.activeTabId);
    return found || state.tabs[state.tabs.length - 1];
  }
}
